/* ============
 * Actions for the reports module
 * ============
 *
 * The actions that are available on the
 * reports module.
 */
import ResolvedReportsProxy from '@/proxies/ResolvedReportsProxy';
import ReportsProxy from '@/proxies/ReportsProxy';
import types from './mutation-types';

export const getEnrolledReports = ({ commit }, data) => {
  commit(types.FETCH_ENROLLED_PATIENT_REPORT_LIST);
  new ReportsProxy().fetchReportsEnrolled(data).then((response) => {
    commit(types.FETCH_ENROLLED_PATIENT_REPORT_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_ENROLLED_PATIENT_REPORT_FAIL, error);
  });
};


export const getResolvedReports = ({ commit }, data) => {
  commit(types.FETCH_RESOLVED_PATIENT_REPORT_LIST);
  new ResolvedReportsProxy().fetchReportsResolved(data).then((response) => {
    commit(types.FETCH_RESOLVED_PATIENT_REPORT_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_RESOLVED_PATIENT_REPORT_FAIL, error);
  });
};

export const getSymptomsReports = ({ commit }, data) => {
  commit(types.FETCH_SYMPTOMS_PATIENT_REPORT_LIST);
  new ResolvedReportsProxy().fetchSymptomsReports(data).then((response) => {
    commit(types.FETCH_SYMPTOMS_PATIENT_REPORT_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_SYMPTOMS_PATIENT_REPORT_FAIL, error);
  });
};


export const getAllPatientList = ({ commit }, data) => {
  commit(types.FETCH_ALL_PATIENT_REPORT_LIST);
  new ReportsProxy().fetchAllPatient(data).then((response) => {
    commit(types.FETCH_ALL_PATIENT_REPORT_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_ALL_PATIENT_REPORT_FAIL, error);
  });
};

export const getPatientReportById = ({ commit },data) => {
  commit(types.FETCH_PATIENTBYID_REPORT_LIST);
  new ReportsProxy().fetchPatientReportBasedOnSelection(data.id,data.selection,data.startdate,data.enddate).then((response) => {
    commit(types.FETCH_PATIENTBYID_REPORT_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_PATIENTBYID_REPORT_FAIL, error);
  });
};

export const getPatientWeeklyReportById = ({ commit },data) => {
  commit(types.FETCH_PATIENTBYID_WEEKLY_REPORT_LIST);
  new ReportsProxy().fetchPatientReportBasedOnSelection(data.id,data.selection,data.startdate,data.enddate).then((response) => {
    commit(types.FETCH_PATIENTBYID_WEEKLY_REPORT_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_PATIENTBYID_WEEKLY_REPORT_FAIL, error);
  });
};

export const getPatientYearlyReportById = ({ commit },data) => {
  commit(types.FETCH_PATIENTBYID_YEARLY_REPORT_LIST);
  new ReportsProxy().fetchPatientReportBasedOnSelection(data.id,data.selection,data.startdate,data.enddate).then((response) => {
    commit(types.FETCH_PATIENTBYID_YEARLY_REPORT_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_PATIENTBYID_YEARLY_REPORT_FAIL, error);
  });
};


export default {
  getEnrolledReports,
  getResolvedReports,
  getSymptomsReports,
  getAllPatientList,
  getPatientReportById,
  getPatientWeeklyReportById,
  getPatientYearlyReportById
};
